import React from 'react';
import { motion } from 'framer-motion';
import { QuoteSlide as QuoteSlideType } from '../../types';
import { SlideContainer } from '../common/SlideComponents';

interface QuoteSlideProps {
  content: QuoteSlideType;
  speakerNotes?: string;
}

export const QuoteSlide: React.FC<QuoteSlideProps> = ({
  content,
  speakerNotes
}) => {
  return (
    <SlideContainer>
      <div className="flex flex-col justify-center items-center min-h-full text-center max-w-5xl mx-auto">
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          {/* Large opening quote mark */}
          <div className="absolute -top-8 -left-8 text-8xl text-muted-teal/30 font-serif">"</div>
          
          <blockquote className="text-4xl md:text-5xl font-light text-soft-black leading-relaxed mb-12 relative z-10">
            {content.quote}
          </blockquote>
          
          {/* Large closing quote mark */}
          <div className="absolute -bottom-8 -right-8 text-8xl text-muted-teal/30 font-serif">"</div>
        </motion.div>
        
        <motion.div
          className="flex flex-col items-center space-y-2 mt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="w-16 h-px bg-warm-gray/50 mb-6"></div>
          
          <cite className="text-2xl font-medium text-deep-slate not-italic">
            {content.author}
          </cite>
          
          {content.authorTitle && (
            <p className="text-xl text-warm-gray font-light">
              {content.authorTitle}
            </p>
          )}
          
          {content.context && (
            <p className="text-lg text-warm-gray/80 font-light italic mt-4 max-w-2xl">
              {content.context}
            </p>
          )}
        </motion.div>
      </div>
      
      {speakerNotes && (
        <div className="absolute bottom-4 left-4 opacity-0 hover:opacity-100 transition-opacity duration-200">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 text-sm text-warm-gray max-w-xs">
            <strong>Speaker Notes:</strong> {speakerNotes}
          </div>
        </div>
      )}
    </SlideContainer>
  );
};